import FinancedSubjectAbstract from "./FinancedSubjectAbstract";
import IFinancedSubjectBase from "./IFinancedSubjectBase";
import FinancedSubjectType from "./FinancedSubjectTypeEnum";
import ICashBase from "./ICashBase";
import ILiabilityBase from "@/module/main/dto/ILiabilityBase";
import IOrderBase from "@/module/main/dto/IOrderBase";
import IWalletBase from "@/module/main/dto/financing-v3/IWalletBase";

export default class FinancedSubjectBase extends FinancedSubjectAbstract implements IFinancedSubjectBase
{
    constructor(public type: FinancedSubjectType = FinancedSubjectType.CASH,
                public cash?: ICashBase,
                public liability ?: ILiabilityBase,
                public order?: IOrderBase,
                public wallet?: IWalletBase,)
    {
        super(type);
    }
}
